module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-47.b963d655.png";